import axios from "axios";

const base_API_CEP_URL = process.env.REACT_APP_API_CEP_URL || "";

const apiCEP = axios.create({
  baseURL: base_API_CEP_URL,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
});

export default apiCEP;
